import Container from "components/core/Layout/Container/Container";
import React, { ReactElement } from "react";
import styles from "./GenericBadgeTags.module.scss";

type Props<T> = {
  unlink?: boolean;
  listData: T[];
  listDisplayLength: number;
  listComponent(props: T): React.ReactElement;
};

export default function GenericBadgeTags<T>(props: Props<T>): ReactElement {
  const [showExpandableTickerSymbols, setExpandableTickerSymbols] =
    React.useState(false);

  return (
    <Container>
      <div className={styles.GenericBadgeTags}>
        {props.listData &&
          props.listData
            .slice(0, props.listDisplayLength)
            .map((genericListItem, i) => (
              <props.listComponent key={`generic-${i}`} {...genericListItem} />
            ))}

        {showExpandableTickerSymbols && (
          <>
            {props.listData &&
              props.listData
                .slice(props.listDisplayLength, props.listData.length)
                .map((genericListItem) => (
                  <props.listComponent {...genericListItem} />
                ))}
          </>
        )}

        {props.listData &&
          props.listData.length > props.listDisplayLength &&
          (showExpandableTickerSymbols ? (
            <a
              onClick={() => {
                setExpandableTickerSymbols(false);
              }}
              className={styles.remainingTagsLink}
            >
              - See Less
            </a>
          ) : (
            <a
              onClick={() => {
                setExpandableTickerSymbols(true);
              }}
              className={styles.remainingTagsLink}
            >
              +{" "}
              {props.listData &&
                props.listData.length - props.listDisplayLength}{" "}
              More
            </a>
          ))}
      </div>
    </Container>
  );
}
